import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { actions as customerActions } from '../redux/customerActions';
import { BackButton, Box, Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';

import CustomerApplications from '../components/CustomerApplications/CustomerApplications';
import CustomerTransactions from '../components/CustomerTransactions/CustomerTransactions';
import CustomerNotes from '../components/CustomerNotes/CustomerNotes';
import CustomerAudit from '../components/CustomerAudit/CustomerAudit';
import InternalTabs from '../../layout/components/InternalTabs/InternalTabs';
import getIncludedResource from '../../../helpers/getIncludedResource';
import CustomerEmails from '../components/CustomerEmails/CustomerEmails';
import CustomerDetails from '../components/CustomerDetails/CustomerDetails';

const TAB_NAME = 'customerTabs';

const TabContainer = ({ label, children }) => (
  <Box>
    <h2 className="resource-name">{label}</h2>
    {children}
  </Box>
);

const CustomerShowContainer = ({ params: { id }, getCustomer, customer, user }) => {
  useEffect(
    () => {
      getCustomer(id, ['policies', 'user']);
    },
    [id, getCustomer],
  );

  const refresh = () => {
    getCustomer(id, ['policies', 'user']);
  };
  const resource = customer.resources[id];

  if (!resource) {
    return (
      <InternalContainer title="Customer" buttons={<BackButton />}>
        <Loader />
      </InternalContainer>
    );
  }

  const availableProducts = getIncludedResource(
    user.data,
    user.included,
    'available_products',
  );
  const customerName = resource.data.attributes.customer_name;

  return (
    <InternalContainer title="Customer" buttons={<BackButton />}>
      <InternalTabs
        id={TAB_NAME}
        tabs={[
          {
            permissions: ['customer.view', 'customer.view_owner'],
            title: 'Details',
            content: (
              <TabContainer label={customerName}>
                <CustomerDetails
                  customer={resource}
                  availableProducts={availableProducts}
                  onRefresh={refresh}
                />
              </TabContainer>
            ),
          },
          {
            permissions: ['policy.quote'],
            title: 'Quote History',
            content: (
              <TabContainer label={customerName}>
                <CustomerApplications
                  customerId={resource.data.id}
                  availableProducts={availableProducts}
                />
              </TabContainer>
            ),
          },
          {
            permissions: ['policy.view'],
            orgTypes: ['owner'],
            title: 'Transactions',
            content: (
              <TabContainer label={customerName}>
                <CustomerTransactions customerId={resource.data.id} />
              </TabContainer>
            ),
          },
          {
            permissions: ['customer.notes_view'],
            orgTypes: ['owner', 'broker'],
            title: 'Notes',
            content: (
              <TabContainer label={customerName}>
                <CustomerNotes customerId={resource.data.id} />
              </TabContainer>
            ),
          },
          {
            permissions: ['system.audit_logs_view'],
            orgTypes: ['owner'],
            title: 'Audit',
            content: (
              <TabContainer label={customerName}>
                <CustomerAudit customerId={resource?.data?.id} />
              </TabContainer>
            ),
          },
          {
            permissions: ['communication.view'],
            orgTypes: ['owner'],
            title: 'Emails',
            content: (
              <TabContainer label={customerName}>
                <CustomerEmails customerId={resource.data.id} />
              </TabContainer>
            ),
          },
        ]}
      />
    </InternalContainer>
  );
};

export default connect(
  (state) => ({
    user: state.auth.user,
    customer: state.customer,
  }),
  {
    getCustomer: customerActions.getCustomer,
  },
)(CustomerShowContainer);
